import { apiFetch } from './client';
import type { Inquiry } from '@/types/api';

export interface InquiryList {
  readonly items: ReadonlyArray<Inquiry>;
  readonly nextCursor?: string;
}

export const inquiriesApi = {
  list(params?: { cursor?: string; limit?: number }): Promise<InquiryList> {
    return apiFetch<InquiryList>('/inquiries', { searchParams: params });
  },

  get(id: string): Promise<Inquiry> {
    return apiFetch<Inquiry>(`/inquiries/${id}`);
  },

  markRead(id: string): Promise<Inquiry> {
    return apiFetch<Inquiry>(`/inquiries/${id}/read`, { method: 'POST' });
  },

  remove(id: string): Promise<void> {
    return apiFetch<void>(`/inquiries/${id}`, { method: 'DELETE' });
  },
};
